(function(){
    'use strict';

    var $smpLangSwitch = $('.smp-lang-switch');

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function updateLanguage (language) {
        $('.megamenu__col--1 a').each(function(){
            if($(this).attr('data-' + language).length) {
                $(this).text($(this).attr('data-' + language));
            }
        });
    }

    function normalizePath(pathname) {
        var path = pathname.replace(/\/$/, '');
        return path === '' ? '/' : path;
    }

    function isHomepage() {
        if ($('body').hasClass('home')) {
            return true;
        }

        var path = normalizePath(window.location.pathname);
        return path === '/' || path === '/reo';
    }

    function getHomepageUrlForLanguage(language) {
        var path = language === 'maori' ? '/reo' : '/';
        return path + window.location.search + window.location.hash;
    }

    if($smpLangSwitch.length){
        $smpLangSwitch.find('button').on('click', function(){
            var language = $(this).attr('data-language');

            setCookie('language', language, 30);
            $smpLangSwitch.find('button').removeClass('active');
            updateLanguage(language);
            $(this).addClass('active');

            if (isHomepage()) {
                var targetPath = language === 'maori' ? '/reo' : '/';

                if (normalizePath(window.location.pathname) !== targetPath) {
                    window.location.assign(getHomepageUrlForLanguage(language));
                }
            }
        });
    }
}());
